import { render } from "./DefaultConfigurationTab.vue?vue&type=template&id=6a87d896"
import script from "./DefaultConfigurationTab.vue?vue&type=script&lang=js"
export * from "./DefaultConfigurationTab.vue?vue&type=script&lang=js"
script.render = render

export default script